import { OrderStatusObject } from 'src/app/models/orders/order-status-object.model';
import { StringUtils } from 'src/app/services/utils/string.utils';

export class ErrorPropertiesObject {

    constructor(private operation: string, private activity: string, private errorCode: string,
        private errorDescription: string, private errorDate: Date,
        private activityStartDate: Date, private orderState: OrderStatusObject) {

    }

    public static create(): ErrorPropertiesObject {
        return new ErrorPropertiesObject(StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE,
            StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, null, null, OrderStatusObject.create());
    }
    public getOperation() {
        return this.operation;
    }

    public getActivity() {
        return this.activity;
    }

    public getErrorCode() {
        return this.errorCode;
    }

    public getErrorDescription() {
        return this.errorDescription;
    }

    public getErrorDate() {
        return this.errorDate;
    }

    public getActivityStartDate() {
        return this.activityStartDate;
    }

    public getOrderState() {
        return this.orderState;
    }
}
